import { render } from "./RequestResetPasswordView.vue?vue&type=template&id=1d68d22e"
import script from "./RequestResetPasswordView.vue?vue&type=script&lang=js"
export * from "./RequestResetPasswordView.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__